<template>
    <b-alert show variant="danger" class="error">
        <span v-if="email">{{ $t('email') }}</span>
        <span v-if="cpf">{{ $t('cpf') }}</span>
        <span v-if="somethingWrong">{{ $t('somethingWentWrong') }}</span>
    </b-alert>
</template>

<script>
export default {
    name: 'FeedbackAuth',
    props: {
        email: {
            type: Boolean,
            default: false,
            required: false,
        },
        cpf: {
            type: Boolean,
            default: false,
            required: false,
        },
        somethingWrong: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    i18n: {
        messages: {
            'en-US': {
                email: 'Incorrect email and/or password.',
                cpf: 'Incorrect Brazilian CPF and/or password. If your Brazilian CPF is not registered, try using the corporate email.',
                somethingWentWrong: 'Something went wrong. Please try again in a few moments.',
            },
            'es-ES': {
                email: 'Correo y/o contraseña incorrecto(s).',
                cpf: 'CPF brasileño y/o contraseña incorrecto(s). Si tu CPF brasileño no está registrado, intenta usar el correo corporativo.',
                somethingWentWrong: 'Algo salió mal. Inténtalo de nuevo en unos momentos.',
            },
            'pt-BR': {
                email: 'Email e/ou senha incorreto(s).',
                cpf: 'CPF e/ou senha incorreto(s). Caso seu CPF não esteja cadastrado, tente usar o email corporativo.',
                somethingWentWrong: 'Algo deu errado. Tente novamente em alguns instantes.',
            },
        },
    },
}
</script>
